import type { MatIconRegistry } from '@angular/material/icon';
import type { DomSanitizer } from '@angular/platform-browser';

import { APP_BUILD_VERSION } from '#/app/app.version';

/**
 * Set Material-symbols-rounded as default icon style.
 * Based on https://github.com/angular/components/issues/24845#issuecomment-2655520316
 * @param iconRegistry
 * @param sanitizer
 */
export const configureMatIconRegistry = (
  iconRegistry: MatIconRegistry,
  sanitizer: DomSanitizer,
) => {
  const defaultFontSetClasses = iconRegistry.getDefaultFontSetClass();
  const roundedFontSetClasses = defaultFontSetClasses
    .filter((fontSetClass) => fontSetClass !== 'material-icons')
    .concat(['material-symbols-rounded']);
  iconRegistry.setDefaultFontSetClass(...roundedFontSetClasses);
  iconRegistry.addSvgIconSet(
    sanitizer.bypassSecurityTrustResourceUrl(
      `icons/material-symbols-sprite.svg?v=${APP_BUILD_VERSION}`,
    ),
  );
};
